import { Pipe, PipeTransform } from '@angular/core';
import { MarketSeaProductsModel } from 'src/app/models/sea/market-sea-products.model';
import { SeaModel } from 'src/app/models/sea/sea-model';

@Pipe({
  name: 'isOverTonnage'
})
export class ProductAvailableTonnagePipe implements PipeTransform {
  transform(item: MarketSeaProductsModel | null | undefined, model?: SeaModel): boolean {

    let overTonnage = false;

  
    

    if(model.operationType == 'FCL') {
      if (!item || !item.freights || !model.tonnage  || !item.freights.availableTonnage) {
        return overTonnage;
      }   
      overTonnage = (item.freights.availableTonnage < model.tonnage || item.isOverLimit)
    } else {
        overTonnage = item.isOverLimit;
    }
 
    return overTonnage
  }
}
